import React from 'react'
import PropTypes from 'prop-types'
import { Edit } from '@sainsburys-tech/luna-icons'

const EditButton = ({ onClick }) => (
  <button
    className="c-icon-button u-bg-none"
    data-control="edit-shelf-artifact"
    onClick={onClick}
    type="button"
  >
    <Edit />
  </button>
)

EditButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default EditButton
